import React, { useRef, useState, useEffect } from 'react';
import SmiWidget from '../SmiWidget';

export const SideBar = ({isFull}) => {
    const [visibleWidgets, setVisibleWidgets] = useState(1);
    const divRef = useRef(null);

    useEffect(() => {
        const updateDivHeight = () => {
            if (divRef.current) {
                const height = divRef.current.offsetHeight;
                if (height < 450) {
                    setVisibleWidgets(1);
                } else if (height < 700) {
                    setVisibleWidgets(2);
                } else if (height < 1000) {
                    setVisibleWidgets(3);
                } else {
                    setVisibleWidgets(4);
                }
            }
        };
        updateDivHeight();
        window.addEventListener('resize', updateDivHeight);
        return () => {
            window.removeEventListener('resize', updateDivHeight);
        };
    }, []);

    return (
        <div className="sticky-block" ref={divRef}>
            <div className="sticky-block-content">
                {visibleWidgets >= 1 && <SmiWidget blockId={isFull ? '30211' : '30172'}/>}
                {visibleWidgets >= 2 && <SmiWidget blockId={'30212'}/>}
                {visibleWidgets >= 3 && <SmiWidget blockId={'30213'}/>}
                {visibleWidgets >= 4 && <SmiWidget blockId={'30214'}/>}
            </div>
        </div>
    );
}
